/* CLAUDE V50 : barre « livraison offerte dès 69 € » (seuil réglé dans meta-tags) + choix du bijou offert dès 100 €.
   Réglages (seuils, noms, photos) : snippet meta-tags, objet window.lvShipBar.
   CLAUDE V54 : « Bijou argenté » et les 3 bijoux au choix sont exclusifs (un seul choix possible).
   CLAUDE V55 : seuil livraison offerte 69 € (point relais comme Colissimo). */
(function () {
  var cfg = window.lvShipBar || {};
  var T1 = cfg.shipping || 6900;
  var T2 = cfg.gift || 10000;
  var gifts = cfg.gifts || [];
  var ATTR = cfg.attribute || 'Bijou offert (dès 100 €)';
  var ATTR2 = cfg.silverAttribute || 'Bijou argenté';
  var timer = null;
  var busy = false;

  function hexUrl(hex) {
    try {
      var h = String(hex || '').replace(/\s+/g, '');
      var bytes = new Uint8Array(h.length / 2);
      for (var i = 0; i < bytes.length; i++) bytes[i] = parseInt(h.substr(i * 2, 2), 16);
      return URL.createObjectURL(new Blob([bytes], { type: 'image/jpeg' }));
    } catch (e) {
      return '';
    }
  }
  gifts.forEach(function (g) {
    g.src = g.img || hexUrl(g.hex);
    g.value = g.value || g.name;
  });

  var css =
    '.lv-ship-bar{margin:0 0 1.6rem;padding:1.2rem 1.6rem 1.4rem;background:#fce4ec;border-radius:1.2rem;text-align:center;}' +
    '.lv-ship-bar__text{margin:0 0 .8rem;font-size:1.4rem;line-height:1.3;color:#121212;}' +
    '.lv-ship-bar__rail{position:relative;height:2.2rem;margin:0 1.1rem;}' +
    '.lv-ship-bar__track{position:absolute;left:0;right:0;top:.65rem;height:.9rem;background:#fff;border-radius:1rem;overflow:hidden;}' +
    '.lv-ship-bar__mark{position:absolute;top:0;width:2.2rem;height:2.2rem;margin-left:-1.1rem;border-radius:50%;background:#fff;border:.2rem solid #e78fab;font-size:1.1rem;line-height:1.8rem;text-align:center;}' +
    '.lv-ship-bar__mark--off{filter:grayscale(1);opacity:.6;border-color:#d9d9d9;}' +
    '.lv-gift{margin-top:1.1rem;padding-top:1rem;border-top:.1rem dashed rgba(18,18,18,.2);}' +
    '.lv-gift__title{margin:0 0 .8rem;font-size:1.3rem;line-height:1.3;color:#121212;}' +
    '.lv-gift__row{display:flex;justify-content:center;align-items:flex-start;gap:.8rem;}' +
    '.lv-gift__item{display:flex;flex-direction:column;align-items:center;gap:.3rem;flex:1 1 0;min-width:0;max-width:10rem;padding:0;border:0;background:none;font:inherit;color:#121212;font-size:1.2rem;line-height:1.2;cursor:pointer;}' +
    '.lv-gift__pic{width:7rem;height:7rem;border-radius:50%;overflow:hidden;background:#fff;border:.3rem solid #fff;box-sizing:border-box;}' +
    '.lv-gift__pic img{width:100%;height:100%;object-fit:cover;display:block;}' +
    '.lv-gift__item--on .lv-gift__pic{border-color:#e78fab;}' +
    '.lv-gift__item--locked{cursor:default;}' +
    '.lv-gift__item--locked .lv-gift__pic img{filter:grayscale(1);opacity:.45;}' +
    '.lv-gift__note{font-size:1.05rem;font-style:italic;}' +
    '.lv-gift__badge{font-size:1.1rem;color:#121212;}' +
    '.lv-gift__silver{display:inline-flex;align-items:center;gap:.6rem;margin:1rem 0 0;font-size:1.3rem;color:#121212;cursor:pointer;}' +
    '.lv-gift__silver--locked{opacity:.45;cursor:default;}' +
    '.lv-gift__silver input{width:1.8rem;height:1.8rem;accent-color:#e78fab;margin:0;}' +
    '.lv-gift__stock{margin:.8rem 0 0;font-size:1.1rem;line-height:1.3;color:#121212;}' +
    '.drawer__contents > .lv-ship-bar{margin:1.2rem 1.5rem 0;}';
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  function money(cents) {
    try {
      return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
    } catch (e) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  function targets() {
    var list = [];
    var drawer = document.querySelector('#CartDrawer-CartItems');
    if (drawer && drawer.querySelector('.drawer__cart-items-wrapper')) list.push(drawer);
    var page = document.querySelector('cart-items .js-contents');
    if (page) list.push(page);
    return list;
  }

  function setAttrs(attrs) {
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () {});
  }

  function text(parts) {
    var p = document.createElement('p');
    p.className = 'lv-ship-bar__text';
    parts.forEach(function (part) {
      if (part.b) {
        var s = document.createElement('strong');
        s.textContent = part.b;
        p.appendChild(s);
      } else {
        p.appendChild(document.createTextNode(part));
      }
    });
    return p;
  }

  function mark(pos, emoji, on) {
    var m = document.createElement('div');
    m.className = 'lv-ship-bar__mark' + (on ? '' : ' lv-ship-bar__mark--off');
    m.style.left = pos + '%';
    m.textContent = emoji;
    return m;
  }

  function giftBlock(total, chosen, silver) {
    var unlocked = total >= T2;
    var wrap = document.createElement('div');
    wrap.className = 'lv-gift';
    var title = document.createElement('p');
    title.className = 'lv-gift__title';
    title.textContent = unlocked ? 'Choisissez votre bijou offert :' : 'Votre bijou offert dès ' + money(T2) + ' d’achat :';
    wrap.appendChild(title);
    var row = document.createElement('div');
    row.className = 'lv-gift__row';
    gifts.forEach(function (g) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'lv-gift__item' + (unlocked ? '' : ' lv-gift__item--locked') + (unlocked && chosen === g.value ? ' lv-gift__item--on' : '');
      b.setAttribute('data-gift', g.value);
      var pic = document.createElement('span');
      pic.className = 'lv-gift__pic';
      var img = document.createElement('img');
      img.src = g.src;
      img.alt = g.name;
      pic.appendChild(img);
      var name = document.createElement('span');
      name.textContent = g.name;
      b.appendChild(pic);
      b.appendChild(name);
      if (g.note) {
        var note = document.createElement('span');
        note.className = 'lv-gift__note';
        note.textContent = '(' + g.note + ')';
        b.appendChild(note);
      }
      var badge = document.createElement('span');
      badge.className = 'lv-gift__badge';
      badge.textContent = unlocked ? (chosen === g.value ? 'Choisi ✓' : 'Offert') : 'Offert dès ' + money(T2);
      b.appendChild(badge);
      if (unlocked) {
        b.addEventListener('click', function () {
          var a = {};
          a[ATTR] = g.value;
          a[ATTR2] = '';
          document.querySelectorAll('.lv-gift__silver input').forEach(function (el) {
            el.checked = false;
          });
          document.querySelectorAll('.lv-gift__item').forEach(function (el) {
            var on = el.getAttribute('data-gift') === g.value;
            el.classList.toggle('lv-gift__item--on', on);
            el.lastChild.textContent = on ? 'Choisi ✓' : 'Offert';
          });
          setAttrs(a);
        });
      }
      row.appendChild(b);
    });
    wrap.appendChild(row);

    var lab = document.createElement('label');
    lab.className = 'lv-gift__silver' + (unlocked ? '' : ' lv-gift__silver--locked');
    var cb = document.createElement('input');
    cb.type = 'checkbox';
    cb.disabled = !unlocked;
    cb.checked = unlocked && silver === 'Oui';
    cb.addEventListener('change', function (ev) {
      ev.stopPropagation();
      var a = {};
      a[ATTR2] = cb.checked ? 'Oui' : '';
      if (cb.checked) {
        a[ATTR] = '';
        document.querySelectorAll('.lv-gift__item').forEach(function (el) {
          el.classList.remove('lv-gift__item--on');
          el.lastChild.textContent = 'Offert';
        });
      }
      document.querySelectorAll('.lv-gift__silver input').forEach(function (el) {
        el.checked = cb.checked;
      });
      setAttrs(a);
    });
    lab.appendChild(cb);
    lab.appendChild(document.createTextNode('Bijou argenté'));
    var wrapSilver = document.createElement('div');
    wrapSilver.appendChild(lab);
    wrap.appendChild(wrapSilver);

    var stock = document.createElement('p');
    stock.className = 'lv-gift__stock';
    stock.textContent = 'Sous réserve des stocks disponibles, à défaut un bijou équivalent vous sera offert.';
    wrap.appendChild(stock);
    return wrap;
  }

  function build(cart) {
    var total = cart.total_price;
    var attrs = cart.attributes || {};
    var chosen = attrs[ATTR] || '';
    var silver = attrs[ATTR2] || '';
    var el = document.createElement('div');
    el.className = 'lv-ship-bar';
    el.setAttribute('role', 'status');

    if (total < T1) {
      el.appendChild(text(['Plus que ', { b: money(T1 - total) }, ' pour profiter de la livraison offerte ! 🚚']));
    } else if (total < T2) {
      el.appendChild(text([{ b: 'Livraison offerte ✓' }, ' Plus que ', { b: money(T2 - total) }, ' pour votre bijou offert ! 🎁']));
    } else {
      el.appendChild(text([{ b: 'Bravo !' }, ' Livraison et bijou offerts 🎉']));
    }

    var percent = Math.max(0, Math.min(100, Math.round((total * 100) / T2)));
    var rail = document.createElement('div');
    rail.className = 'lv-ship-bar__rail';
    var track = document.createElement('div');
    track.className = 'lv-ship-bar__track';
    track.setAttribute('aria-hidden', 'true');
    track.style.background = 'linear-gradient(90deg, #e78fab ' + percent + '%, #ffffff ' + percent + '%)';
    rail.appendChild(track);
    rail.appendChild(mark(Math.round((T1 * 100) / T2), '🚚', total >= T1));
    rail.appendChild(mark(100, '🎁', total >= T2));
    rail.lastChild.style.marginLeft = '-2.2rem';
    el.appendChild(rail);

    if (gifts.length) el.appendChild(giftBlock(total, chosen, silver));

    if (total < T2 && (chosen || silver)) {
      var clear = {};
      clear[ATTR] = '';
      clear[ATTR2] = '';
      setAttrs(clear);
    }
    return el;
  }

  function check() {
    if (busy) return;
    var missing = targets().filter(function (t) {
      return !t.querySelector(':scope > .lv-ship-bar');
    });
    if (!missing.length) return;
    busy = true;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.item_count) return;
        missing.forEach(function (t) {
          if (!t.querySelector(':scope > .lv-ship-bar')) t.insertBefore(build(cart), t.firstChild);
        });
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(check, 120);
  }

  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', schedule);
  schedule();
})();